import { render } from "./DiscoverComponent.vue?vue&type=template&id=7a5bc684"
import script from "./DiscoverComponent.vue?vue&type=script&lang=js"
export * from "./DiscoverComponent.vue?vue&type=script&lang=js"

import "./DiscoverComponent.vue?vue&type=style&index=0&id=7a5bc684&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__